import { PayloadAction } from '@reduxjs/toolkit';

import { PreviewState, The3dPreview } from 'editor/src/store/editorModules/preview/types';

const setThe3dPreviewReducer = (state: PreviewState, action: PayloadAction<The3dPreview | undefined>) => {
  state.the3dPreview = action.payload;
};

export default setThe3dPreviewReducer;
